module.exports = __webpack_public_path__ + "img/status-end-or-old.efbed0b7.png";